
    import I18n from 'i18nObj';
    
      import 'translations/quizzes.no_quizzes_view';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('quizzes.no_quizzes_view');
  